export const QRTYPE = [
  { id: 'Qr30', qrName: 'Qr30' },
  { id: 'QrCs', qrName: 'QrCs' },
  { id: 'Wechat', qrName: 'Wechat' },
  { id: 'Alipay', qrName: 'Alipay' }
];
